<template>
  <div id="DetallesView">
    <TopPanel
      :tabs="[
        { label: 'Caracterización', path: '/caracterizacion/' },
        { label: 'Rating', path: '/rating/' },
        { label: 'Materia prima', path: '/materiaprima/' }
      ]"
      @year-changed="onYearChanged"
    />
    <div v-if="generalData && Object.keys(generalData).length" class="grid-wrapper">
      <div class="grid-principal">
        <div class="cuad cuad-1">
          <div class="cuad-1-superior">
            <v-card class="card card-ubicacion">
              <h4 class="title">Ubicación</h4> 
              <p class="big-value">
                {{ generalData.productor.ubicacion_predio }}
              </p>
            </v-card>
            <v-card class="card card-productos">
              <h4 class="title">Productos</h4>
              <div class="treemap-holder">
                <TreeMap :data="maptreeData" />
              </div>
            </v-card>
          </div>
          <div class="cuad-1-inferior">
            <v-card class="card card-capital">
              <h4 class="title">Capital Humano</h4>
              <p class="subtitle">Total Trabajadores</p>
              <div class="bar-standard bar-blue" style="justify-content:center;">
                Cantidad: &nbsp; <span style="font-size:18px;">{{ generalData.trabajadores.total }}</span>
              </div>
            </v-card>
            <v-card class="card card-formacion">
              <h4 class="title">Formación</h4>
              <div class="formacion-grid">

                <div :class="['bar-standard', 'bar-flex', generalData.trabajadores.postgrado > 0 ? 'bar-blue' : '']">
                  <span>Postgrado:</span> 
                  <span>{{ generalData.trabajadores.postgrado }}</span>
                </div>
                <div :class="['bar-standard', 'bar-flex', generalData.trabajadores.pregrado > 0 ? 'bar-blue' : '']">
                  <span>Pregrado:</span> 
                  <span>{{ generalData.trabajadores.pregrado }}</span>
                </div>
                <div :class="['bar-standard', 'bar-flex', generalData.trabajadores.media > 0 ? 'bar-blue' : '']">
                  <span>E. Media:</span> 
                  <span>{{ generalData.trabajadores.media }}</span>
                </div>                
                <div :class="['bar-standard', 'bar-flex', generalData.trabajadores.basica > 0 ? 'bar-blue' : '']">
                  <span>E. Básica:</span> 
                  <span>{{ generalData.trabajadores.basica }}</span>
                </div>
              </div>
            </v-card>
            <v-card class="card card-capacitacion">
              <h4 class="title">Capacitación</h4>
              <p class="mini">(Frecuencia cap. BPA)</p>
              <div :class="['bar-standard', generalData.trabajadores.frecuencia_capacitacion_bpa !== 'No disponible' ? 'bar-blue' : '']">
                {{ generalData.trabajadores.frecuencia_capacitacion_bpa }}
              </div>

              <p class="mini mt-1">(Frecuencia cap. Seguridad)</p>
              <div :class="['bar-standard', generalData.trabajadores.frecuencia_capacitacion_seguridad !== 'No disponible' ? 'bar-blue' : '']">
                {{ generalData.trabajadores.frecuencia_capacitacion_seguridad }}
              </div>
            </v-card>
          </div>
        </div>
        <div class="cuad cuad-2">
          <v-card class="card card-rating">
            <h4 class="title">Rating</h4>
            <p class="subtitle">Productores</p>
            <p class="mini">
              Buenas Prácticas Sostenibilidad Agrícola (BPSA)
            </p>
            <div class="chart-holder rating-holder">
              <img
                :src="ratingImage"
                alt="Rating BPSA"
                class="rating-img"
              />
            </div>
          </v-card>
          <v-card class="card card-percepcion card-center">
            <h4 class="title">Percepción</h4>
            <p class="subtitle">Prácticas Agrícolas</p>
            <div class="chart-holder">
              <StackColumnVertical
                :data_chart="chartSeries"
                :height_chart="'100%'"
                :promedio_linea="promedioPercepcionAnual"
              />
            </div>
          </v-card>
        </div>
        <div class="cuad cuad-3">
          <v-card class="card card-comercializacion card-center">
              <h4 class="title">Comercialización</h4>
              <div class="chart-holder">
                <PieChart
                  :data_chart="PieChartData"
                  :key="selectedProducer"
                />
              </div>
            </v-card>
          <div class="cuad-3-right">
            <v-card class="card card-produccion">
              <h4 class="title">Producción</h4>
              <p class="subtitle">(todos los productos)</p>
              <p class="mini label-ton">Total Anual (Ton)</p>
              <div class="bar-standard bar-blue prod-bar">
                {{ generalData.cultivos.total_produccion_anual.replace('.', ',') }}
              </div>
              <div class="spacer-flex"></div>
            </v-card>
            <v-card class="card card-evolucion card-center">
              <h4 class="title">Evolución producción</h4>
              <p class="mini">(Últimos 5 años)</p>
              <div class="evo-grid">
                <div :class="['bar-standard', generalData.cultivos.evolucion_produccion === 3 ? 'bar-blue' : '']">
                  Aumento
                </div>
                <div :class="['bar-standard', generalData.cultivos.evolucion_produccion === 2 ? 'bar-blue' : '']">
                  Igual
                </div>
                <div :class="['bar-standard', generalData.cultivos.evolucion_produccion === 1 ? 'bar-blue' : '']">
                  Disminución
                </div>
              </div>
              <div class="spacer-flex"></div>
            </v-card>
          </div>
        </div>
        <div class="cuad cuad-4">
          <div class="cuad-4-superior">
            <v-card class="card card-residuos">
              <h4 class="title">Gestión de Residuos</h4>
              <div class="residuos-grid">
                <div class="res-col">
                  <div class="res-col-text">
                    <p>Realiza Gestión<br/>Residuos Orgánicos</p>
                  </div>
                  <div class="res-col-bars">
                    <div :class="['bar-standard', generalData.residuos.gestion_residuos_organicos === 3 ? 'bar-green' : 'bar-gray']">Siempre</div>
                    <div :class="['bar-standard', generalData.residuos.gestion_residuos_organicos === 2 ? 'bar-green' : 'bar-gray']">A veces</div>
                    <div :class="['bar-standard', generalData.residuos.gestion_residuos_organicos === 1 ? 'bar-green' : 'bar-gray']">Nunca</div>
                  </div>
                </div>
                <div class="res-col">
                  <div class="res-col-text">
                    <p>Realiza Gestión<br/>Residuos No Orgánicos</p>
                  </div>
                  <div class="res-col-bars">
                    <div :class="['bar-standard', generalData.residuos.gestion_residuos_no_organicos === 3 ? 'bar-green' : 'bar-gray']">Siempre</div>
                    <div :class="['bar-standard', generalData.residuos.gestion_residuos_no_organicos === 2 ? 'bar-green' : 'bar-gray']">A veces</div>
                    <div :class="['bar-standard', generalData.residuos.gestion_residuos_no_organicos === 1 ? 'bar-green' : 'bar-gray']">Nunca</div>
                  </div>
                </div>
              </div>
            </v-card>
            <v-card class="card card-agua card-center">
              <h4 class="title">Consumo agua</h4>
              <p class="mini">(Total anual M³)</p>
              <div class="bar-standard bar-blue prod-bar">
                {{ generalData.cultivos.consumo_anual_agua.replace('.', ',') }}
              </div>
            </v-card>
          </div>
          <div class="cuad-4-inferior">
            <v-card class="card card-mini">
              <h4 class="title">Certificaciones</h4>
              <div class="content-wrapper">
                <div class="square-pills">
                  <span :class="square(generalData.certificaciones[0] !== 'No tiene')">Sí</span>
                  <span :class="square(generalData.certificaciones[0] === 'No tiene')">No</span>
                </div>
              </div>  
            </v-card>
            <v-card class="card card-mini">
              <h4 class="title">Trazabilidad</h4>
              <div class="content-wrapper">
                <div class="square-pills">
                  <span :class="square(generalData.trazabilidad.realiza_trazabilidad === 'Si')">Sí</span>
                  <span :class="square(generalData.trazabilidad.realiza_trazabilidad === 'No')">No</span>
                </div>
              </div>
            </v-card>
            <v-card class="card card-registro">
              <h4 class="title">Registro</h4>
              <div class="content-wrapper">
                <div class="registro-bars">
                  <div :class="['bar-standard', generalData.trazabilidad.forma_registro === 3 ? 'bar-green' : 'bar-gray']">
                    Cuaderno C. Digital
                  </div>
                  <div :class="['bar-standard', generalData.trazabilidad.forma_registro === 2 ? 'bar-green' : 'bar-gray']">
                    Cuaderno C. Impreso
                  </div>
                  <div :class="['bar-standard', generalData.trazabilidad.forma_registro === 1 ? 'bar-green' : 'bar-gray']">
                    No realiza
                  </div>
                </div>
              </div>
            </v-card>
            <v-card class="card card-mini">
              <h4 class="title">Frecuencia registro</h4>
              <div class="content-wrapper">
                <div class="freq-pills">
                  <span v-for="n in [1,2,3,4,5]" :key="n" :class="freq(n)">
                    {{ n }}
                  </span>
                </div>
                <p class="mini">{{ frecuenciaTexto }}</p>
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center mt-5">
      Selecciona un productor para ver los detalles.
    </div>
  </div>
</template>

<script>
import StackColumnVertical from '../components/charts/stackColumnVertical.vue';
import PieChart from '../components/charts/PieChart.vue';
import TreeMap from '../components/charts/TreeMap.vue';
import TopPanel from '@/components/layout/TopPanel.vue';
import YearPicker from '@/components/YearPicker.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'DetallesView',
  components: {
    TopPanel,
    TreeMap,
    PieChart,
    StackColumnVertical,
    YearPicker,
  },

  computed: {
    ...mapState(['generalData', 'selectedYear']),
    ...mapGetters(['producersByYear']),
    selectedProducer() {
      return this.$route.params.producerId;
    },
    ratingImage() {
      const r = this.generalData.productor?.ranking_bpsa || 'F';
      return require(`../media/rating/${r}.png`);
    },
    chartSeries() {
      const v = this.generalData.productor?.percepcion || 0;
      const diff = 100 - v;
      const productor = this.producersByYear.find(
        (p) => String(p.id) === String(this.selectedProducer)
      );
      return {
        series: [
          { name: productor?.nombre || 'Prod', data: [v] },
          { name: '', data: [diff] },
        ],
        categorias: ['Percepción'],
      };
    },
    frecuenciaTexto() {
      const f = this.generalData.trazabilidad.frecuencia_registro;
      return {
        1: 'Nunca',
        2: 'Rara vez',
        3: 'A veces',
        4: 'A menudo',
        5: 'Siempre',
      }[f] || '';
    },
    PieChartData() {
      if (!this.generalData?.cultivos) return { title: '', serie: [], categories: [], colors: [] };
      const c = this.generalData.cultivos;
      return {
        title: c.producto_mayor_produccion || 'Sin Título',
        serie: [
          c.porcentaje_internacional || 0,
          parseInt(c.porcentaje_regional) || 0,
          parseInt(c.porcentaje_nacional) || 0,
        ],
        categories: ['Internacional', 'Regional', 'Nacional'],
        colors: ['#79A6E8', '#5390EA', '#103E8E'],
      };
    },
    promedioPercepcionAnual() {
      if (this.selectedYear === 2024) return 71.35; //valor adaptado para que la linea roja quede justo en el rango 
      if (this.selectedYear === 2025) return 85.00; //valor adaptado para que la linea roja quede justo en el rango
      // Idealmente, obtendría este valor de su store o API:
      // return this.$store.getters.getPromedioPercepcion(this.selectedYear);
      return 0; // Valor por defecto
    },
    maptreeData() {
      if (!this.generalData?.cultivos?.lista_cultivos) return { serie: [], colors: [] };
      const cultivos = this.generalData.cultivos.lista_cultivos;
      const colorMapping = {
        Pimiento: '#62B238',
        Ají: '#F4731B',
        Dátil: '#C35B1B',
        Tomate: '#DC1933',
        Aceituna: '#488A29',
        'Tomate Cherry': '#F31C17',
        Maíz: '#FAD829',
        Albahaca: '#3ABB5C',
        Maracuyá: '#E1BF26',
        Guayaba: '#EB8180',
        Limón: '#E6ED6F',
        Ajo: '#E7A6E1',
        Berenjena: '#2A7629',
        Orégano: '#44B443',
        Pepino: '#9DE080',
      };
      const colors = cultivos.map(
        (c) => colorMapping[c.producto] || '#CCCCCC'
      );
      return {
        serie: cultivos.map((cultivo) => ({
          x: cultivo.producto || 'Sin Producto',
          y: parseFloat(cultivo.produccion_anual) || 0,
          producto: cultivo.producto || 'Sin Producto',
          pertinencia: cultivo.grado_pertinencia_cultivo || 'Sin Pertinencia',
          practica: cultivo.practica_agricola || 'Sin Práctica',
          sellos: cultivo.sello || 'No tiene',
          produccion: `${cultivo.produccion_anual || 0} Ton`,
        })),
        colors,
      };
    },
  },

  methods: {
    ...mapActions(['fetchGeneralData']),

    onYearChanged(y) {
      this.$store.commit('setSelectedYear', y);
      this.$store.dispatch('hydrateProducersByYear', y);
    },

    pill(v) {
      return v ? 'pill-blue' : 'pill-gray';
    },
    pillText(v) {
      return v && v !== 'No disponible' ? 'pill-blue' : 'pill-gray';
    },
    pillGreen(v) {
      return v ? 'pill-green' : 'pill-gray';
    },
    square(v) {
      return v ? 'square-green' : 'square-gray';
    },
    freq(n) {
      return this.generalData.trazabilidad.frecuencia_registro === n ? "active" : "";
    },
  },

  watch: {
    selectedProducer: {
      immediate: true,
      handler(id) {
        if (id) this.fetchGeneralData(id);
      },
    },
  },
};
</script>
<style scoped>
:root {
  /* ---------- TITULACIÓN ---------- */
  --font-title: 1.05rem;        /* Título de cada card */
  --font-subtitle: 0.92rem;     /* Subtítulo o etiqueta secundaria */
  --font-mini: 0.75rem;         /* Texto de aclaración */
  --font-value-large: 3rem;   /* Valores destacados */
  --font-value: 2.4rem;         /* Valores medianos */
  /* ---------- GRAFICOS ---------- */
  --font-chart-label: 0.78rem;       /* Etiquetas de barras/pie/treemap */
  --font-chart-legend: 0.72rem;      /* Leyendas de categorías */
  /* ---------- PILLS ---------- */
  --font-pill: 0.78rem;            /* Texto dentro de pills */
}
/* ===== CONTENEDOR GENERAL ===== */
#DetallesView {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  overflow-x: hidden; /* Evita scroll horizontal */
  overflow-y: hidden /* CRÍTICO: Evita scroll vertical en el contenedor raíz */
}
/* Wrapper para separar del borde */
.grid-wrapper {
  /* 🏆 Ocupa todo el espacio restante bajo el TopPanel */
  flex: 1;
  padding: 4px 4px 4px 4px;
  box-sizing: border-box;
  overflow: hidden; 
  /* CRÍTICO: Asegura que el contenedor principal respeta el límite */
  min-height: 0;

}
/* ===== GRID PRINCIPAL 2×2 (CUADRANTES) ===== */
.grid-principal {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Cuadrantes 1 y 2 */
  grid-template-rows: 1fr 1fr; /* Mitad superior / inferior */
  height:100%;
  gap: 6px;
  box-sizing: border-box;
}
/* Cada cuadrante */
.cuad {  
  min-height: 0; 
  height: 100%; 
  display: grid;
}
/* ====== TARJETAS GENERALES ====== */
.card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  padding: 4px;
  background: #ffffff;
  border-radius: 8px; /* suave, moderno */
  border: 1.5px solid #d4d6d9; /* línea MUY tenue */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.16); /* ⭐ sombra uniforme */
  /* CRÍTICO: Evita que el contenido interno fuerce el crecimiento de la card */
  min-height: 0;
}
.card:hover {
  transform: translateY(-2px);
  transition: 0.2s ease;
  box-shadow: 0 6px 14px rgba(0,0,0,0.15);
}
/* TITULOS Y TIPOGRAFÍA */
.title {
  font-weight: 600;
  font-size: var(--font-title);
  color: #555;
  margin: 0 0 6px 0;
}
.subtitle {
  font-size: var(--font-subtitle);
  color: #666;
  margin-bottom: 4px;
}
.mini {
  font-size: var(--font-mini);
  color: #777;
  margin: 0;
}
.mt-1 {
  margin-top: 6px;
}
/* Valores */
.big-value,
.value-blue.big {
  font-size: 2rem;
  font-weight: 700;
  color: #3550b8;
}
.value-blue {
  color: #3550b8;
  font-weight: 700;
  font-size: var(--font-value);
}
.value-small {
  font-size: 0.8rem;
  color: #555;
}
.apexcharts-text {
  font-size: var(--font-chart-label) !important;
  font-family: inherit;
}
.apexcharts-legend-text {
  font-size: var(--font-chart-legend) !important;
}
/* ---- ALINEACIONES POR TIPO CARD ---- */
/* Centro general */
.card-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
/* Izquierda general */
.card-left {
  text-align: left;
  align-items: flex-start;
}
/* Centro exacto para cards pequeñas cuadradas */
.card-center-small {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
/* === BARRAS ESTÁNDAR PARA TODA LA VISTA === */
.bar-standard {
  background-color: #9fa0a1;    /* gris suave fondo */
  border-radius: 8px;
  height: 28px;                /* altura uniforme */
  display: flex;
  align-items: center;
  justify-content: center;       /* CENTRADO DEL TEXTO */
  padding: 0 12px;
  font-size: var(--font-pill);
  color: #fffdfd;
  font-weight: 500;
  width: 70%;                    /* CONTROLA ANCHO DE TODAS LAS BARRAS */
  box-sizing: border-box;
}
.bar-blue {   
  background-color: #3550b8 !important;
  color: white !important;
  font-weight: 600;
}
.bar-green {
  background-color: #52b120 !important;
  color: white !important;
  font-weight: 600;
}
.bar-gray {
  background-color: #9fa0a1 !important;
  color: white !important;
  font-weight: 500;
}
.card-capital .bar-standard,
.card-formacion .bar-standard,
.card-capacitacion .bar-standard {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}
/* ============================================== */
/* CUADRANTE 1 — GENERAL + UBICACION + PRODUCTOS  */
/* ============================================== */
.cuad-1 {   
  display: grid;
  grid-template-rows: 1fr 1fr; /* fila superior / inferior mismas alturas */
  height: 100%;               
  gap: 4px;
  overflow: hidden;  
}
/* Fila superior: Ubicación (1/3) + Productos (2/3) */
.cuad-1-superior {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 4px;
}
/* Fila inferior: Capital, Formación, Capacitación (1/3 cada una) */
.cuad-1-inferior {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}
.card-ubicacion {
  align-items: center; 
  justify-content: flex-start;
  height: 100%;
  text-align: center; 
}
.card-ubicacion .big-value {
  flex: 1;                        /* ocupa todo el espacio bajo el título */
  display: flex;
  align-items: center;            /* centra verticalmente el texto */
  justify-content: flex-start;   /* alineado a la izquierda (como ahora) */
  margin: 0;                      /* quitamos márgenes extra si los hubiera */
}
.card-productos {
  align-items: center; 
  justify-content: flex-start;
  height: 100%;
  text-align: left; 
}
.cuad-1 .treemap-holder {
  width: 100%;
  height: 100%;          /* ocupa toda la celda asignada */
  max-height: 100%;      /* NO permitir que ApexCharts empuje hacia afuera */
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;      /* evita que el gráfico sobrepase el borde */
}
/* Contenedor específico del treemap */
.chart-holder.treemap {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;        /* <--- evita deformaciones verticales */
  overflow: hidden;           /* evita que Apex se salga visualmente */
  padding-bottom: 6px;
}
/* Fuerza al SVG interno a ajustarse al espacio disponible */
.chart-holder.treemap > * {
  height: 100%;
  width: 100%;
  max-height: 100%;
}
/* ==== CAPITAL HUMANO ==== */
.card-capital {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Títulos al top */
  padding-top: 6px;
}
/* ==== FORMACION ==== */
.card-formacion {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Títulos al top */
  padding-top: 6px;
}
.formacion-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
}
/* Formación — texto + número con separación */
.bar-flex {
  gap: 6px; /* Pequeña separación */
}
/* Fila de formación — evita que el "2" quede pegado a la derecha */
.bar-standard span.value {
  margin-left: 4px;
}
/* ==== CAPACITACION ==== */
.card-capacitacion {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Títulos al top */
  padding-top: 6px;
}
/* ============================================ */
/* CUADRANTE 2 — GENERAL + RATING + PERCEPCION  */
/* ============================================ */
.cuad-2 {
  display: grid;
  grid-template-columns: 2fr 1fr; /* Rating 2/3, Percepción 1/3 */
  height: 100%; 
  gap: 4px;
  overflow: hidden;  
}
/* ==== RATING ==== */
.card-rating {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rating-holder {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.rating-img {
  width: 80%;         /* controla tamaño */
  max-height: 80%;    /* respeta proporción */
  object-fit: contain;
  display: block;
}
/* ==== PERCEPCION ==== */
.card-percepcion {
  display: flex;
  flex-direction: column;
  padding: 4px 6px;
}
.card-percepcion .title {
  margin-bottom: 4px;
}
.card-percepcion .subtitle {
  margin-bottom: 6px;
  font-size: var(--font-subtitle);
}
.card-percepcion .chart-holder {
  flex: 1;
  margin-top: 0;
  padding: 0;
  height: calc(100% - 50px);  /*resta título + subtítulo */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.card-percepcion .chart-holder > * {    /* fuerza al gráfico a usar todo el alto */
  height: 100% !important;
  width: 100% !important;
}
/* ======================================================= */
/* CUADRANTE 3 — COMERCIALIZACIÓN - PRODUCCIÓN + EVOLUCIÓN */
/* ======================================================= */
.cuad-3 {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 2fr 1fr; /* Comercialización 2/3, derecha 1/3 */
  gap: 4px;
  overflow: hidden;
}
.cuad-3-right {
  display: grid;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 4px;
}
/* Asegurar que las tarjetas dentro de cuad-3-right usen el 100% */
.cuad-3-right .card {
  height: 100%;
}
.card-comercializacion {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%; /* Asegura que la tarjeta ocupa el 100% de la celda */
  min-height: 0;
}
/* TÍTULO: Elimina cualquier margen inferior en el título */
.card-comercializacion .title {
    margin-bottom: 0; 
    padding-bottom: 4px; 
}
/* SOLUCIÓN FINAL: Fuerza al gráfico interno a ocupar el 100% del contenedor */
.card-comercializacion .chart-holder {
  flex: 1; /* Ocupa todo el espacio restante bajo el título */
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 0;
  overflow: hidden;
  padding: 8px; 
}
/* REGLA MAESTRA: Sobreescribe cualquier limitación del DIV interno del gráfico */
.card-comercializacion .chart-holder > div {
  width: 100% !important; 
  height: 100% !important; 
  max-width: 100%;
  max-height: 100%;
}
/* Ajuste card Producción */
.card-produccion {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Títulos al top */
  padding-top: 6px;
  min-height: 0;
  /* CRÍTICO: Debe ser height: 100% para que el spacer funcione */
  height: 100%;
}
/* Regla para el nuevo Spacer */
.spacer-flex {
  flex: 1; /* Ocupa el 100% del espacio vertical restante */
  width: 100%; 
}
.card-produccion .title {
  margin-bottom: 2px;
}
.card-produccion .subtitle {
  margin-bottom: 6px;
  color: #666;
}
/* Etiqueta Total Anual */
.label-ton {
  margin-top: 4px;
  font-size: 0.82rem;
  color: #555;
}
/* Barra con el valor */
.prod-bar {
  margin-top: 6px;
  width: 70%;       /* Igual a barras de Formación */
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
}
/* Estilo para barras de Evolución Producción */
.evo-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  margin-top: 8px;
}
/* Estilo para card Evolución */
.card-evolucion {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Títulos al top */
  min-height: 0;
  height: 100%;
}
.card-evolucion .bar-standard {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}
.mini-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 1.2;
}
/* ================================================================ */
/* CUADRANTE 4 — GESTIÓN RESIDUOS + CONSUMO AGUA                    */
/*+ CERTIFICACIONES + TRAZABILIDAD + REGISTRO + FRECUENCIA REGITRO  */
/* ================================================================ */
.cuad-4 {
  display: grid;
  grid-template-rows: repeat(2, minmax(0, 1fr)); 
  gap: 4px;
  overflow: hidden;
}
/* Fila superior: Residuos (2/3) + Agua (1/3) */
.cuad-4-superior {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-auto-rows: 1fr;       
  gap: 4px;
}
/* NUEVA REGLA: Forzar a las tarjetas de Residuos y Agua a usar el 100% de altura */
.cuad-4-superior .card {
  height: 100%;
}
/* Fila inferior — 4 cards pequeñas  */
.cuad-4-inferior {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* cuatro iguales */
  grid-auto-rows: 1fr;       
  gap: 4px;
}
/* ===== FIX SOLO PARA LAS MINI CARDS DEL CUADRANTE 4 ===== */
.cuad-4-inferior .card {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  padding: 4px; /* Usa el padding general de .card */
}
.residuos-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 12px;
  height: 100%; /* Ocupar el alto disponible */
  align-items: center; /* Centrar verticalmente el contenido */
  margin-bottom: 0 !important; 
}
.card-registro,
.card-center-small {
  padding-bottom: 6px;   
}
.card-residuos {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;  
  padding-top: 4px;
  padding-bottom: 4px;
  margin: 0;
  height: 100%; /* Asegura que la tarjeta de Residuos usa su 100% */
}
.card-residuos .title {
  text-align: center;
}
.card-agua {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 4px;
  padding-bottom: 4px;
  margin: 0;                 
}
.card-agua > *:last-child {
  margin-top: 4px;
  margin-bottom: 0;
}
/* Fila izquierda texto | barras */
.res-col {
  display: flex;
  align-items: center;  
  gap: 12px; 
}
/* Texto alineado verticalmente */
.res-col-text {
  width: 100px;   
  font-size: var(--font-mini);
  color:#777;
  line-height: 1.2; 
  display: flex;
  flex-direction: column;
  justify-content: center; 
}
/* Apila barras */
.res-col-bars {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
/* Barras */
.res-col-bars .bar-standard {
  width: 200px;
  height: 32px;
  border-radius: 10px;
  padding: 6px;
  margin: 0 !important; 
}
/* === CARD REGISTRO — SOLO BARRAS CENTRADAS === */
/* Registro */
.reg-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
}
.card-registro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 6px;
}
/* contenedor vertical limpio */
.registro-bars {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly; /* distribuye vertical */
  align-items: center; /* centrado perfecto */
  gap: 6px;
  width: 100%;
  margin-top: 6px;
}
/* barras con el mismo estilo que residuos */
.registro-bars .bar-standard {
  width: 70%;           
  max-width: 260px;     
}
/* === MINI CARDS ESTÉTICA UNIFICADA === */
/* Ajuste fino — evita desbordes por márgenes internos */
.card-mini, .card-registro {
  padding-top: 4px;
  padding-bottom: 4px;
}
.card-mini {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 6px;
}
.card-mini .title {
  margin-bottom: 6px;
}
.mini-block {
  margin-top: 6px;
  display: flex;
  gap: 6px;
  justify-content: center;
}
/* === PASTILLAS CUADRADAS (Certificaciones & Trazabilidad) === */
.square-pills span {
  padding: 20px 20px;       
  font-size: 0.95rem;      
  border-radius: 6px;
  font-weight: 600;
}
/* === FRECUENCIA REGISTRO → CÍRCULOS === */
.freq-pills {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 6px 0;
}
.freq-pills span {
  width: 32px;              /* tamaño del círculo */
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;       /* lo hace circular */
  font-size: 0.90rem;
  font-weight: 600;
  color: #fff;
  background-color: #c4c4c4;
}
/* Activo (verde) cuando coincide el valor */
.freq-pills .active {
  background-color: #52b120;
}
/* Nuevo CSS para centrar el contenido bajo el título */
.content-wrapper {
  flex: 1; /* Absorbe TODO el espacio vertical restante de la tarjeta */
  display: flex;
  flex-direction: column;
  justify-content: center; /* CENTRA verticalmente el contenido dentro de este wrapper */
  align-items: center;
  width: 100%; /* Asegura que no haya problemas de ancho */
  overflow: hidden; /* Evita desbordamientos si la pantalla es muy pequeña */
}
/* Redondas para frecuencia */
.rounded-green,
.rounded-gray {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 0.72rem;
  font-weight: bold;
  color: #fff;
}
.rounded-green {
  background: #52b120;
}
.rounded-gray {
  background: #c4c4c4;
}
/* Cuadradas para Sí/No */
.square-green,
.square-gray {
  width: 32px;
  height: 24px;
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 500;
}
.square-green {
  background: #52b120;
}
.square-gray {
  background: #c4c4c4;
}
.square-pills {
  display: flex;
  gap: 6px;
  margin-top: 4px;
}
/* ============================================= */
/* ===== RESPONSIVIDAD 4K+ (3800px o más) ===== */
/* ============================================= */
@media (min-width: 2000px) {
  /* 🏆 CORRECCIÓN DE ALTURA SOLO PARA PANTALLAS ULTRA-GRANDES (3800x2400+) */
  /* Aplica la compensación de altura manual que estabiliza el layout en resoluciones muy altas. */
  .cuad-3,
  .cuad-4 {
      height: calc(100% - 150px); 
  }
}
/* ============================================= */
/* ===== RESPONSIVIDAD LAPTOP/TABLET (601px a 2000px) ===== */
/* META: Colapsar el Grid Principal a columna (Q1, Q2, Q3, Q4 apilados) */
@media (max-width: 2000px) {
  /* A. Main Grid Collapse (4x1 stack) */
  .grid-principal {
    display: flex;
    flex-direction: column; /* Apila Q1, Q2, Q3, Q4 en ese orden */
    height: auto;
    gap: 12px; /* Aumenta el espacio entre los cuadrantes apilados */
  }

  /* B. Fixes para que el contenido fluya y permita scroll */
  #DetallesView {
    height: auto; 
    min-height: 100vh;
    overflow-y: auto; 
  }
  .grid-wrapper {
    flex: none; 
    height: auto;
    min-height: auto;
  }
  
  /* C. Cuadrantes y sub-grids: Stack Vertical */
  .cuad {  
    height: auto !important; 
    min-height: auto; /* Permite que el contenido dicte la altura */
  }
  .cuad-3, .cuad-4 {
    height: auto !important; /* Anular corrección 4K */
  }
  
  /* D. Colapso de sub-estructuras a una columna (dentro de cada Q) */
  .cuad-1-superior, 
  .cuad-1-inferior,
  .cuad-2,          
  .cuad-3,          
  .cuad-3-right,    
  .cuad-4-superior 
  {
    display: flex; 
    flex-direction: column;
    gap: 8px;
    height: auto;
  }

  /* E. Cards y Mini-Cards */
  .card {
    height: auto !important; 
    flex: none !important; 
    width: 100%; 
    min-height: 180px; 
  }
  
  /* F. Mini-Cards (Cuad 4 Bottom): Pasan a 2x2 para tablets/laptops */
  .cuad-4-inferior {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    height: auto;
  }
}

/* ========================================= */
/* ===== RESPONSIVIDAD MÓVIL (< 600px) ===== */
/* ========================================= */
/* META: Mantiene 4x1 y asegura que todas las sub-estructuras colapsan a columna única. */
@media (max-width: 600px) {
  /* A. Main Grid Collapse (Ya está colapsado, mantenemos ajustes) */
  .grid-principal {
    gap: 12px;
  }
  /* Fix: Centrado de la tarjeta de Residuos en móvil */
  .card-residuos {
    align-items: center;
    padding: 10px 4px; /* Aumentamos el padding para mejor aspecto */
  }
  /* B. Fix para Residuos: Aseguramos que Residuos (Orgánicos/No Orgánicos) se apilan */
  .residuos-grid {
    grid-template-columns: 1fr; /* Una columna */
    justify-content: center; 
    align-items: center;
    gap: 12px;
  }
  .res-col {
    flex-direction: column; /* Apila el texto sobre las barras */
    align-items: flex-start;
  }
  .res-col-text {
    width: 100%;
    text-align: left;
  }
  .res-col-bars .bar-standard {
    max-width: none; 
  }
  /* C. Mini-Cards Collapse (4x1) */
  .cuad-4-inferior {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  /* D. Ajustes de tipografía para pantallas muy pequeñas */
  .card-ubicacion .big-value {
    font-size: 1.5rem;
    justify-content: center;
    text-align: center;
    padding: 8px 0;
  }
  .square-pills span {
    padding: 10px 15px;       
    font-size: 0.85rem;
  }

}
</style>